import React from 'react';
import { Accordion, Icon } from 'ui';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import SelectedCriteriaList from './SelectedCriteriaList';

const Title = ({ criteria }) => (
  <div>
    <Text variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD}>
      {t('feedback_criteria.feedback_criteria')} ({criteria.length})
    </Text>

    <span
      className="ml-4"
      data-toggle="tooltip"
      title={t('feedback_criteria.description')}
      data-placement="top"
    >
      <Icon name="info" className="c-brand-gray-dark" />
    </span>
  </div>
);

const FeedbackCriteria = ({
  selectedCriteria,
  handleUpdate,
  canUseCustomFeedbackCriteria,
}) => (
  <Accordion
    title={<Title criteria={selectedCriteria} />}
    small
    className="mt-10"
  >
    <SelectedCriteriaList
      canUseCustomFeedbackCriteria={canUseCustomFeedbackCriteria}
      selectedCriteria={selectedCriteria}
      handleUpdate={handleUpdate}
    />
  </Accordion>
);

export default FeedbackCriteria;
